import Model, { attr } from '@ember-data/model';

import type { Slack } from 'webapp-types';
import { ReportLayout } from 'webapp/enums/enums';

import type { ScheduleUser } from 'webapp/models-custom/schedule';
import { DEFAULT_NOTE as DEFAULT_NOTE_BOARD } from 'webapp/models/board-share';

export const DEFAULT_NOTE = DEFAULT_NOTE_BOARD.replace('dashboard', 'report');

export default class ReportScheduleSettingRecord extends Model {
	@attr('number') reportId!: number;
	@attr('number') created!: number;
	@attr('number') createdBy!: number;
	@attr('array', {
		defaultValue() {
			return [];
		},
	})
	recipients!: string[];
	@attr('array', {
		defaultValue() {
			return [];
		},
	})
	slackChannels!: Slack.Channels;
	@attr('string', { defaultValue: '' }) subject!: string;
	@attr('string', { defaultValue: DEFAULT_NOTE }) note!: string;
	@attr('string') password!: string; // unused

	@attr('number') scheduledOn!: number; // timestamp, only for "generate now, send later" case

	@attr('number', { defaultValue: 3 }) scheduleType!: number;
	@attr('number', { defaultValue: 9 }) scheduleHourOfDay!: number | null;
	@attr('array', {
		defaultValue() {
			return [];
		},
	})
	scheduleDayOfWeek!: number[];
	@attr('number', { defaultValue: -1 }) scheduleDayOfMonth!: number | null;
	@attr('object') scheduleUser!: ScheduleUser | null;

	@attr('number', { defaultValue: ReportLayout.PAGELESS }) declare layout: ReportLayout;
	@attr('boolean', { defaultValue: false }) declare includeBgImages: boolean;

	// @attr('boolean', { defaultValue: false }) approvalRequired!: boolean;
	// @attr('array', { defaultValue() { return []; } }) approvalIds!: number[];
}
